import { useNavigate } from "react-router-dom";
import { useCrawlers } from "@/context/CrawlerContext";
import { LayoutDashboard, FileStack, ClipboardCheck, History, ArrowRight } from "lucide-react";

const MODES = [
  {
    to: "/dashboard", Icon: LayoutDashboard, testId: "card-dashboard",
    title: "Crawler-Dashboard",
    desc: "Alle Crawler im Blick: Status, letzter Lauf und zuletzt abgeholte Hefte. Einzeln oder alle auf einmal starten.",
    accent: "bg-[#0F4C81]",
  },
  {
    to: "/hefte", Icon: FileStack, testId: "card-hefte",
    title: "PP (Pre Processing)",
    desc: "Frisch gecrawlte Hefte nach Status bearbeiten — Neu, Fertig, Alle. PDF ansehen und Gliederung/XML pflegen.",
    accent: "bg-emerald-600",
  },
  {
    to: "/ok", Icon: ClipboardCheck, testId: "card-ok",
    title: "OK",
    desc: "Alle fertigen Hefte prüfen und mit OK, Not OK oder Unklar bewerten — oder zur Nachbearbeitung zurückstellen.",
    accent: "bg-amber-600",
  },
  {
    to: "/protokoll", Icon: History, testId: "card-protokoll",
    title: "Hefte Heute",
    desc: "Vollständiges Protokoll: wer hat wann welche Aktion an welchem Heft durchgeführt (Crawler-Start, Fertig, Statuswechsel, Zurückstellen).",
    accent: "bg-violet-600",
  },
];

export default function ModeSelect() {
  const navigate = useNavigate();
  const ctx = useCrawlers();
  const crawlers = ctx?.crawlers || [];
  const running = crawlers.filter((c) => ctx?.statusOf(c) === "running").length;

  return (
    <div className="h-full overflow-y-auto">
      <div className="mx-auto max-w-6xl px-6 py-14">
        <div className="mb-10">
          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-gray-900 tracking-tight">Betriebsmodus wählen</h1>
          <p className="mt-2 text-gray-500 text-base">
            {crawlers.length} Crawler registriert{running > 0 ? ` · ${running} laufen gerade` : ""}. Wähle einen Modus — du kannst jederzeit oben wechseln.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {MODES.map(({ to, Icon, title, desc, accent, testId }, i) => (
            <button
              key={to}
              onClick={() => navigate(to)}
              data-testid={testId}
              style={{ animationDelay: `${i * 80}ms` }}
              className="group text-left bg-white border border-gray-200 rounded-2xl p-7 shadow-sm hover:shadow-xl hover:-translate-y-1 hover:border-[#0F4C81]/40 transition-all duration-300 flex flex-col"
            >
              <div className={`h-12 w-12 rounded-xl ${accent} flex items-center justify-center shadow-sm`}>
                <Icon className="h-6 w-6 text-white" strokeWidth={2} />
              </div>
              <h2 className="mt-5 font-heading text-xl font-bold text-gray-900">{title}</h2>
              <p className="mt-2 text-sm text-gray-500 leading-relaxed flex-1">{desc}</p>
              <span className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold text-[#0F4C81] group-hover:gap-2.5 transition-all">
                Öffnen <ArrowRight className="h-4 w-4" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
